import { render } from "./SuperAdminTable.vue?vue&type=template&id=1b0e4f99&scoped=true"
import script from "./SuperAdminTable.vue?vue&type=script&lang=js"
export * from "./SuperAdminTable.vue?vue&type=script&lang=js"

import "./SuperAdminTable.vue?vue&type=style&index=0&id=1b0e4f99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0e4f99"]])

export default __exports__